
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 30.8c7.622 0 13.8-6.178 13.8-13.8 0-7.622-6.178-13.8-13.8-13.8C9.378 3.2 3.2 9.378 3.2 17c0 7.622 6.178 13.8 13.8 13.8z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M22.4 11l-4-.3c-.7-.1-1.1.3-1.3.8 0 .6.4 1.1.9 1.1l1.8.1-8.6 8.6-.3.3c-.4.4-.4 1.1 0 1.4.4.4 1.1.4 1.4 0l2.7-2.7 6.2-6.2.1 1.8c0 .6.5.9 1.1.9.3 0 .4-.1.6-.4.2-.3.4-.5.4-.8l-.3-4c-.1-.1 0-.1-.1-.2l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1c0 .1-.1.2-.1.1z","fill":"#fff"}})])
          )
        }
      }
    